export function ensureNumber(data?: string | number) {
  if (!data) {
    return 0;
  }
  const value = typeof data === 'number' ? data : parseInt(data);
  return Number.isFinite(value) ? value : 0;
}
